<template>
  <div class="udan-ems-dialog">
    <!-- 更新提示框 -->
    <el-dialog :title="$t('个人信息')" :visible.sync="dialogVisible" class="dialog-personal" width="600px" :before-close="handleClose">
      <el-form :model="personalForm" class="detail-form">
        <el-form-item :label="$t('账号名称') + '：'">
          <span>{{ personalForm.userName || '-' }}</span>
        </el-form-item>
        <el-form-item :label="$t('账号邮箱') + '：'">
          <span>{{ personalForm.userEmail || '-' }}</span>
        </el-form-item>
        <el-form-item :label="$t('账号手机') + '：'">
          <span>{{ personalForm.userTel || '-' }}</span>
        </el-form-item>
        <el-form-item :label="$t('账号角色') + '：'">
          <el-row class="station-list">
            <el-col :span="5" class="station-name" v-for="(item, index) in personalForm.roleNames" :key="index">
              <span>{{ item }}</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('创建时间') + '：'">
          <span>{{ personalForm.createTime || '-' }}</span>
        </el-form-item>
        <el-form-item :label="$t('创建人') + '：'">
          <span>{{ personalForm.createUserName || '-' }}</span>
        </el-form-item>
        <el-form-item :label="$t('到期时间') + '：'">
          <span>{{ personalForm.expiredTimeStr || '-' }}</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="footer-side-center">
          <el-button @click="handleClose">{{ $t('返回') }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import { userManageInfo } from '@/api/userManage'
  export default {
    name: 'PersonalInfoDialog',

    data() {
      return {
        personalForm: {},
        dialogVisible: false
      }
    },
    watch: {
      dialogVisible: {
        deep: true,
        handler: function () {
          if (this.dialogVisible) {
            this.getPersonalInfo()
          }
        }
      }
    },
    mounted() {},
    methods: {
      handleClose() {
        this.dialogVisible = false
      },
      getPersonalInfo() {
        userManageInfo().then((res) => {
          if (res && res.data.code == 200) {
            this.personalForm = { ...res.data.data }
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  ::v-deep .dialog-personal {
    .el-dialog__header {
      height: 54px;
      padding: 0 24px !important;
      line-height: 54px;
      border-bottom: 1px solid #e8e8e8;
      .el-dialog__title {
        color: rgb(0 0 0 / 90%);
        font-size: 16px;
        line-height: 24px;
      }
    }
    .el-form-item {
      margin-bottom: 30px;
      margin-right: 0;
      .el-form-item__label {
        color: #777777;
        line-height: 1;
      }
      .el-form-item__content {
        line-height: 1;
        span {
          color: #000000 !important;
        }
      }
    }
    .el-dialog__footer {
      padding: 0 32px 30px;
      .el-button {
        padding: 7px 30px;
        border-radius: 2px;
      }

      .footer-side-center {
        text-align: center;
      }
    }
  }
</style>
